const masterBreakPoint = "@media (max-width: 900px),(max-height:600px)" // tablet
const minmaxBreakPoint = "@media (max-width: 600px),(max-height:600px)" // tablet
const largeWidthBreakPoint = "@media (max-height: 400px) and (min-width: 600px)"

const minWidth400 = "@media (min-width: 400px)"
const minWidth600 = "@media (min-width: 600px)"
const minWidth1200 = "@media (min-width: 1300px)"
const minWidth1500 = "@media (min-width: 2000px)"

const maxWidth300 = "@media (max-width: 320px)"
const maxWidth400 = "@media (max-width: 400px)"
const maxWidth450 = "@media (max-width: 450px)"
const maxWidth500 = "@media (max-width: 500px)"
const maxWidth600 = "@media (max-width: 600px)"
const maxWidth700 = "@media (max-width: 700px)"
const maxWidth900Potrait =
  "@media (max-width: 900px) and (orientation: portrait)"
const maxWidth820Potrait =
  "@media (max-width: 820px) and (orientation: portrait)"
const maxWidth900 = "@media (max-width: 900px)"

const maxWidth950Landscape =
  "@media (max-width: 950px) and (orientation: landscape)"
const minWidth1000Landscape =
  "@media (min-width: 1000px) and (orientation: landscape)"

const maxWidth1000 = "@media (max-width: 1000px) and (orientation: portrait)"
const maxWidth1200 = "@media (max-width: 1200px)"

const minHeight400 = "@media (max-height: 400px)"
const maxHeight500 = "@media (max-height: 500px)"
const maxHeight600 = "@media (max-height: 600px)"
const maxHeight800 = "@media (max-height: 800px)"
const maxHeight900 = "@media (max-height: 900px)"

const orientationPortrait = "@media (orientation: portrait)"
const orientationLandscape = "@media (orientation: landscape)"

const tabletPortrait =
  "@media (min-width: 600px) and (max-width: 1024px) and (orientation: portrait)"
const tabletMediaRange = "@media (min-width: 601px) and (max-width: 1299px)"

const shortDesktop = "@media (max-height: 700px) and (min-width: 951px)"
const tallDesktop = "@media (min-height: 950px) and (min-width: 900px)"
const maxWidth1100Landscape =
  "@media (max-width: 1100px) and (orientation: landscape)"

const maxHeight700 = "@media (max-height: 700px)"

// for touch devices
const hoverNone = "@media (hover: hover) and (pointer: fine)"

export {
  masterBreakPoint,
  minmaxBreakPoint,
  largeWidthBreakPoint,
  maxWidth300,
  maxWidth400,
  maxWidth450,
  maxWidth500,
  maxWidth600,
  maxWidth700,
  maxWidth900Potrait,
  maxWidth900,
  maxWidth950Landscape,
  minWidth1000Landscape,
  maxWidth1000,
  maxWidth1200,
  minWidth400,
  minWidth600,
  minWidth1200,
  minWidth1500,
  minHeight400,
  maxHeight600,
  maxHeight900,
  orientationPortrait,
  orientationLandscape,
  tabletPortrait,
  tabletMediaRange,
  shortDesktop,
  tallDesktop,
  maxWidth1100Landscape,
  maxHeight700,
  maxWidth820Potrait,
  maxHeight500,
  hoverNone,
  maxHeight800,
}
